import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';


interface Site {
    id?: number;
    nom?: string;
    description?: string;
    email?: string;
    adresse?: string;
    tel1?: string;
    tel2?: string;
    tel3?: string;
    token?: string;
    about?: string;
    mission?: string;
    objectif?: string;
    politique?: string;
    condition?: string;
    logo?: string;
    logoFile?: File;
    facebook?: string;
    linkedin?: string;
    twitter?: string;
    youtube?: string;
    whatsapp?: string;
    createdAt?: string;
    updatedAt?: string;
}
interface UiValeur {
    id?: number;
    titre?: string;
    description?: string;
    icone?: string;
    createdAt?: string;
    updatedAt?: string;
}
export default function Valeur() {

    const [sites, setSites] = useState<Site[]>([]);
    const [valeurs, setValeur] = useState<UiValeur[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);


    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Site>('/fetch_data_site');
            setSites(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiValeur>('/fetch_valeur_data');
            setValeur(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchData();
        fetchListCategorie();
    }, []);


    return (
        <section className="container py-5">
            {/* HEADER */}
            <div className="text-center mb-4">
                <h2 className="fw-bold display-10">
                    Nos <span className="text-primary">Valeurs Fondatrices</span>
                </h2>
                <p className="lead text-muted">
                    Ce qui forge l'identité, la discipline et l’esprit d’Ouragan Academy.
                </p>
            </div>

            {/* GRID VALUES */}
            <div className="row text-center g-4">

                {valeurs.length === 0 ? (
                    <LoaderAndError
                        loading={loading}
                        error={error}
                        onClearError={() => setError(null)}
                    />
                ) : (
                    valeurs.map((item, index) => (
                        <div className="col-md-6 col-lg-4" key={index}>
                            <div
                                className="
                                    project-card shadow-sm rounded-4 border-0 h-100 
                                    overflow-hidden bg-white dark:bg-gray-900
                                    transition-all duration-300 hover:shadow-xl hover:-translate-y-1
                                "
                            >
                                <div className="card-body p-4 text-center">

                                    {/* ICON */}
                                    <div
                                        className="
                                            icon-xl rounded-circle mx-auto mb-4
                                            bg-primary bg-opacity-10 text-primary
                                            d-flex align-items-center justify-content-center
                                            transition-all duration-300 hover-icon
                                        "
                                        style={{ width: "80px", height: "80px", fontSize: "32px" }}
                                    >
                                        <i className={item.icone}></i>
                                    </div>

                                    {/* TITLE */}
                                    <h4 className="fw-bold text-primary">{item.titre}</h4>

                                    {/* DESCRIPTION */}
                                    <p className="text-muted">
                                        {item.description}
                                    </p>

                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </section>


    )
}
